import { One } from '@granlupo/api-client/generated/content/zeus'
import type { InferGetServerSidePropsType } from 'next'
import { useRouter } from 'next/router'
import { RespondWithNotFound, RespondWithRedirect, serverPropsHandler } from '../libs/next/api/handlers'
import { websiteContent } from '../libs/next/loaders/graphql/src/contentClient'
import { Content } from '../src/components/content/Content'
import { Container } from '../src/components/shared/Container'
import { Layout } from '../src/components/shared/Layout'
import { InternalLink } from '../src/const/Links'
import { ContentFragment } from '../src/data/ContentFragment'
import { LayoutFragment } from '../src/data/LayoutFragment'
import { SeoFragment } from '../src/data/SeoFragment'
import style from '../src/styles/StaticPage.module.sass'

export type ContactPageProps = InferGetServerSidePropsType<typeof getServerSideProps>

export default function ContactPage(props: ContactPageProps) {
	const contactPage = props.data.getContactPage
	const router = useRouter()
	const { preview } = router.query

	return (
		<Layout
			hasBreadcrumbs
			footer={props.data.footer.getFooter}
			socials={props.data.socials.listSocial}
			seo={props.data.getContactPage?.seo}
			url={InternalLink.Contact}
		>
			<Container size="normal">
				<div className={style.content}>
					<Content blocks={preview ? (contactPage?.draft?.blocks ?? []) : (contactPage?.content?.blocks ?? [])} />
				</div>
			</Container>
		</Layout>
	)
}

export const getServerSideProps = serverPropsHandler(async (context) => {
	context.res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate=3600')
	const content = websiteContent

	const url = String(context.defaultLocale)

	const data = await content('query')({
		...LayoutFragment(),
		getContactPage: [
			{ by: { unique: One.One } },
			{
				seo: [{}, SeoFragment()],
				draft: [{}, ContentFragment()],
				content: [{}, ContentFragment()],
				title: true,
			},
		],
		getRedirect: [
			{ by: { from: url } },
			{
				from: true,
				to: true,
				contactPage: [{}, { title: true }],
			},
		],
	})

	if (!data.getContactPage) {
		if (data.getRedirect) {
			const redirect = {
				permanent: true,
				destination: `/${data.getRedirect.contactPage?.title}` || String(data.getRedirect.to),
			}
			throw new RespondWithRedirect(redirect)
		} else {
			throw new RespondWithNotFound('404 Error: Page not found')
		}
	}

	return {
		props: {
			data,
		},
	}
})
